import localStorageService from '@/util/local-storage-service'

export default function auth ({ next, router }) {
  if (!localStorageService.getUserAccessToken()) {
    return next()
  }

  return router.push({ name: 'Dashboard' }).catch(() => {})
}
